"use client";

import { Divider } from "#/components/Divider/Divider";

import { EarningsSection } from "./components/EarningsSection";
import { useEarningsController } from "./Earnings.controller";

export const Earnings = () => {
  const { referralBalance, krystalsEarned } = useEarningsController();

  return (
    <div className="relative flex h-19 w-full justify-between rounded-md bg-[url('/images/components/rewards-earnings-bg.png')] bg-cover bg-center bg-no-repeat p-4 shadow-[0px_2px_14px_0px_rgba(201,201,201,0.50)] sm:h-29 sm:p-8 dark:shadow-none">
      <EarningsSection
        isReferralBalance
        amount={referralBalance}
        title="Active Referral Balance"
      />

      <Divider
        isHorizontal={false}
        className="absolute inset-0 m-auto h-11 bg-white/15 sm:h-13"
      />

      <EarningsSection
        amount={krystalsEarned}
        title="Krystals earned"
        isReferralBalance={false}
      />
    </div>
  );
};
